import ChooseCompanyPage from './main';

const routes = [
  {
    path: '/*',
    Component: ChooseCompanyPage,
    props: {},
  },
];

export default routes;
